import { Validators } from '@angular/forms';

export const AlphanumericValidator = Validators.pattern(/^[А-Яа-яA-Za-z0-9\s]+$/);
export const FlatValidator = Validators.pattern(/^[A-Za-z0-9|.,\s]+$/);
